import { create } from "zustand";
import { DateTime } from "luxon";

type InitialVisitStore = {
  uniqueId: string | undefined;
  setUniqueId: (uniqueId: string) => void;
  date: DateTime;
  setDate: (date: DateTime) => void;
  visibleMonth: DateTime;
  setVisibleMonth: (month: DateTime) => void;
  selectedProvider: {
    label: string;
    value: string;
  };
  setSelectedProvider: (provider: { label: string; value: string }) => void;
  providerOptions: { label: string; value: string }[];
  setProviderOptions: (options: { label: string; value: string }[]) => void;
  selectedSlot: {
    uniqueId: string;
    start: DateTime;
    end: DateTime;
    providerId: string;
  } | null;
  setSelectedSlot: (
    slot: {
      uniqueId: string;
      start: DateTime;
      end: DateTime;
      providerId: string;
    } | null
  ) => void;
  bookingStatus: "initial" | "confirmed" | "error" | "waitlist";
  setBookingStatus: (
    status: "initial" | "confirmed" | "error" | "waitlist"
  ) => void;
  waitlist: boolean;
  setWaitlist: (waitlist: boolean) => void;
};

export const useInitialVisitStore = create<InitialVisitStore>((set) => ({
  uniqueId: undefined,
  setUniqueId: (uniqueId: string) => set({ uniqueId }),
  date: DateTime.now().startOf("day"),
  setDate: (date: DateTime) => set({ date }),
  visibleMonth: DateTime.now().startOf("month"),
  setVisibleMonth: (month: DateTime) =>
    set({ visibleMonth: month.startOf("month") }),
  selectedProvider: { label: "All Providers", value: "all" },
  setSelectedProvider: (provider: { label: string; value: string }) =>
    set({ selectedProvider: provider }),
  providerOptions: [],
  setProviderOptions: (options: { label: string; value: string }[]) =>
    set({ providerOptions: options }),
  selectedSlot: null,
  setSelectedSlot: (
    slot: {
      uniqueId: string;
      start: DateTime;
      end: DateTime;
      providerId: string;
    } | null
  ) => set({ selectedSlot: slot }),
  bookingStatus: "initial",
  setBookingStatus: (status: "initial" | "confirmed" | "error" | "waitlist") =>
    set({ bookingStatus: status }),
  waitlist: false,
  setWaitlist: (waitlist: boolean) => set({ waitlist })
}));
